import { oldBaseApi } from "../../api";

export const findUserByIdOld = (userId: string): Promise<any> => {
  return oldBaseApi.get(`/api/users/user/${userId}`).then((r) => r.data);
};
